import React from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'

import { forgotSchema, UserForgotForm } from '../../../validators/auth.schemas'
import Input from '../../../components/Input'
import Button from '../../../components/Button'
import { Container, ContentCenter, Form } from '../../../components/commons'
import { useNavigate } from 'react-router-dom'
import useToast from '../../../hooks/useToast'
import { api } from '../../../services/api'
import axios from 'axios'
import { ResponseError } from '../../../validators/utils.interface'
import { useConfigStore } from '../../../store/config'
import Avatar from '../../../components/Avatar'

export interface ForgotProps {}

const Forgot: React.FunctionComponent<ForgotProps> = () => {
  const navigate = useNavigate()

  const config = useConfigStore((state) => state).config

  const toast = useToast()
  const [loading, setLoading] = React.useState<boolean>(false)

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<UserForgotForm>({
    defaultValues: {
      email: '',
    },
    resolver: yupResolver(forgotSchema),
  })

  const onSubmit = async (formData: UserForgotForm) => {
    try {
      setLoading(true)

      await api.post('/forgot', formData)

      toast.successToast('Email enviado com sucesso !')
      return navigate('/login')
    } catch (error) {
      const typedError = error as ResponseError
      if (axios.isAxiosError(error)) {
        toast.errorToast(typedError?.response?.data?.message)
      } else {
        toast.errorToast('Erro ao trocar senha, verifique os dados e tente !')
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <Container>
      <ContentCenter>
        <Avatar borderRadius={15} width={150} height={150} source={config?.logo} />
      </ContentCenter>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Input
          placeholder='Email'
          error={errors?.email}
          control={control}
          type='email'
          name='email'
        />

        <Button
          label='Recuperar'
          loading={loading}
          type='submit'
          variantType='block'
          color='secondary'
        />
        <ContentCenter>
          <Button
            onClick={() => navigate('/login')}
            label='Voltar'
            variantType='label'
            color='primary'
          />
        </ContentCenter>
      </Form>
    </Container>
  )
}

export default Forgot
